import { useState } from 'react';
import './App.css';
import logo from './assets/logo.png';
import hero from './assets/hero.jpg';

// Photos
import img1 from './assets/IMG_7075.jpg';
import img2 from './assets/IMG_7070.jpg';
import img3 from './assets/img1.JPG';
import img4 from './assets/img3.JPG';
import img5 from './assets/img4.jpg';
import img6 from './assets/imge5.jpg';
import img7 from './assets/image6.jpg';
import img8 from './assets/img7.JPG';

// Flyers
import f1 from './assets/f1.jpg';
import f2 from './assets/f2.jpg';
import f3 from './assets/f3.jpg';
import f4 from './assets/f4.jpg';

// Video Thumbnails
import t1 from './assets/newest.jpg';
import t2 from './assets/dg.png';
import t3 from './assets/t3.jpg';
import t4 from './assets/t4.jpg';

const photoImages = [img5, img2, img1, img6]; // 4 photos
const flyerImages = [f1, f2, f3, f4]; // 4 flyers
const videoThumbnails = [t1, t2, t3, t4]; // custom video thumbnails

const App = () => {
    const [galleryState, setGalleryState] = useState({
        isOpen: false,
        currentImageIndex: 0,
        imageSet: []
    });

    const [videos, setVideos] = useState({
        gqsZIfqgL28: false,
        oWbvACdxja0: false,
        "-6w9uxj_8Oo": false,
        giEfV2Z0GF4: false
    });


    const openGallery = (index, imageSet) => {
        setGalleryState({
            isOpen: true,
            currentImageIndex: index,
            imageSet: imageSet
        });
    };

    const closeGallery = () => {
        setGalleryState({ ...galleryState, isOpen: false });
    };

    const navigateGallery = (direction) => {
        const newIndex = (galleryState.currentImageIndex + direction + galleryState.imageSet.length) % galleryState.imageSet.length;
        setGalleryState({ ...galleryState, currentImageIndex: newIndex });
    };

    const loadVideo = (videoId) => {
        setVideos(prev => ({ ...prev, [videoId]: true }));
    };

    return (
        <div className="antialiased">
            {/* Hero Section */}
            <header
                className="hero"
                style={{
                    backgroundImage: `linear-gradient(rgba(0,0,0,0.65), rgba(0,0,0,0.65)), url(${hero})`
                }}
            >
                <div className="relative z-20 flex flex-col items-center max-w-4xl mx-auto">
                    <img src={logo} alt="171 Pitakotuwa Logo" className="hero-logo" />
                    <h1 className="hero-title">171 Pitakotuwa</h1>
                    <p className="hero-subtitle">
                        A theatrical production that uses the statue of A.E. Gunasinghe as a symbolic lens to explore the struggles of the working class.
                    </p>
                </div>
            </header>

            <main className="main-container">
                {/* Play Summary */}
                <section className="my-16 grid grid-cols-1 lg:grid-cols-2 gap-8">
                    <div className="section-card">
                        <h2 className="section-title">Play Summary</h2>
                        <p>
                            171 Pitakotuwa is a thought-provoking monologue that uses A.E. Gunasinghe, a key figure in Sri Lanka’s labor movement and a founding member of the Sri Lankan Labour Party, as a symbolic lens to explore the lives of common people and the complexities of politics. Set against the backdrop of Gunasinghe’s neglected statue near Colombo’s Pettah, the play delves into the political awakening of the labor community through the character of Sunil and his bus, which reflects the connection Gunasinghe had with the Labour Movement. This narrative highlights the struggles faced by ordinary Sri Lankans, portraying humanity in shades of gray, emphasizing that no leader or individual is entirely virtuous or wholly flawed. Through its compelling storytelling, 171 Pitakotuwa connects these themes to global struggles, underscoring the universal relevance of political and societal issues. The play invites audiences to reflect on leadership, morality, and the enduring challenges of the working class, making it both a deeply Sri Lankan story and a universally resonant narrative that speaks to the shared human experience.
                        </p>
                    </div>
                </section>

                {/* Photos Section */}
                <section id="photos" className="my-16 text-center">
                    <h2 className="section-title">Photos</h2>
                    <div className="image-grid">
                        {photoImages.map((src, index) => (
                            <div key={index} className="image-card" onClick={() => openGallery(index, photoImages)}>
                                <img src={src} alt={`Play Photo ${index + 1}`} />
                            </div>
                        ))}
                    </div>
                </section>

                {/* Flyers Section */}
                <section id="flyers" className="my-16 text-center">
                    <h2 className="section-title">Flyers</h2>
                    <div className="image-grid">
                        {flyerImages.map((src, index) => (
                            <div key={index} className="image-card" onClick={() => openGallery(index, flyerImages)}>
                                <img src={src} alt={`Flyer ${index + 1}`} />
                            </div>
                        ))}
                    </div>
                </section>

                {/* Videos Section */}
                <section id="videos" className="my-16 text-center">
                    <h2 className="section-title">Promo Videos</h2>
                    <div className="video-grid">
                        {Object.keys(videos).map((videoId, i) => (
                            <div key={i} className="video-container">
                                {!videos[videoId] ? (
                                    <div className="video-thumbnail" onClick={() => loadVideo(videoId)}>
                                        <img src={videoThumbnails[i]} alt={`Video Thumbnail ${i + 1}`} />
                                        <div className="video-play-btn">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                <path d="M8 5v14l11-7z" />
                                            </svg>
                                        </div>
                                    </div>
                                ) : (
                                    <iframe
                                        className="video-iframe"
                                        src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
                                        title="YouTube video player"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    ></iframe>
                                )}
                            </div>
                        ))}
                    </div>
                </section>

                {/* Static Credits Section */}
                <section id="credits" className="credits-section my-16">
                    <h2 className="section-title">Credits</h2>

                    {/* Core Credits (no heading) */}
                    <p><strong>Director:</strong> Banula Wijesinghe</p>
                    <p><strong>Playwright:</strong> Banula Wijesinghe</p>
                    <p><strong>Performer:</strong> Gimhan Samod</p>
                    <p><strong>Producers:</strong> P.H. Wijesinghe, Senila Wijesinghe</p>
                    <p><strong>Music Director:</strong> Amindu Aishwarya Weerasinghe</p>
                    <p><strong>Bassist:</strong> Sathsara Peelikumbura</p>
                    <p><strong>Cajon:</strong> Ruwan Buddhika</p>
                    <p><strong>Singer & Guitar:</strong> Shan D Senadheera</p>
                    <p><strong>Guitar:</strong> Dilshan Prabhashana</p>
                    <p><strong>Song Melody:</strong> Dilshan Prabhashana</p>
                    <p><strong>Song Lyrics:</strong> Vihanga Wijesinghe</p>
                    <p><strong>Stage Managers:</strong> Pulathisi Wedagedara, Yasiru Helaruwan</p>
                    <p><strong>Sound Design:</strong> Banula Wijesinghe</p>
                    <p><strong>Light Designer:</strong> Ranga Kariyawasam</p>
                    <p><strong>Choreographer:</strong> Banula Wijesinghe</p>
                    <p><strong>Makeup:</strong> Madushanka Gamage</p>
                    <p><strong>Costume Design:</strong> Sewwandi Withanage</p>
                    <p><strong>Set Design:</strong> Ranga Kariyawasam</p>
<br/>
                    {/* Promotions Section */}
                    <p className="credits-subheading mt-8">Promotions</p>
                    <p><strong>DOP:</strong> Banula Wijesinghe</p>
                    <p><strong>Photography:</strong> Tithira Paranahewa</p>
                    <p><strong>HMUA:</strong> Lahiru Nishan</p>
                    <p><strong>Artworks:</strong> Thimira Viraj</p>
                    <p><strong>Theme Music:</strong> Banuka Pelawatta (BMP Studio)</p>
                    <p><strong>Content Strategy & Planning:</strong> Wevontis</p>
                    <p><strong>Content Creation:</strong> Vihanga Wijesinghe (Wevontis)</p>
                    <p><strong>Content Creation:</strong> Dulmina Wijegunarathna (Wevontis)</p>
                    <p><strong>Voice Overs:</strong> Athula Jayasinghe</p>
                    <p><strong>Voice Overs:</strong> Malithi Prabhashwari</p>
                    <p><strong>Sound Effects & Foley:</strong> Thuvindu Muthukumara (Asit Studios)</p>
<br/>
                    {/* Special Thanks Section */}
                    <p className="credits-subheading mt-8">Special Thanks</p>
                    <p>My Family</p>
                    <p>Nipuna Balasooriya</p>
                    <p>Damith Aluthgama</p>
                    <p>Sumudu Thenniarachchi</p>
                    <p>Dilshan Thilanka</p>
                    <p>Ovin Abhisheka Bandara</p>
                    <p>Devinda Wickramasinghe</p>
                    <p>Dinura Nagasinghe</p>
                    <p>Lakmali De Silva</p>
                    <p>Dr. Somarathna Wanniarachchi</p>
                    <p>Somesh Dilushan</p>
                    <p>Miran Charuka</p>
                    <p>Ranga Manupriya</p>
                    <p>Basker Krishan</p>
                    <p>Gagana Swetha</p>
                    <p>Uditha Liyanage</p>
                    <p>M Safeer & CITF CREW</p>
                    <p>All the bus drivers and conductors who let us use their buses</p>
                    <p>All the supporters and even the non-supporters</p>
                </section>



            </main>

            <footer className="footer">
                <h3>Banula Wijesinghe</h3>
                <p>Director - 171 Pitakotuwa</p>
                <p>© 2024 Pulse Stage. All rights reserved.</p>
            </footer>

            {/* Gallery Modal */}
            {galleryState.isOpen && (
                <div className="gallery-modal show" onClick={closeGallery}>
                    <div className="gallery-image-container" onClick={e => e.stopPropagation()}>
                        <img src={galleryState.imageSet[galleryState.currentImageIndex]} alt="Gallery" />
                        <span className="close-btn" onClick={closeGallery}>X</span>
                        <div className="gallery-nav-btn prev" onClick={() => navigateGallery(-1)}>&#10094;</div>
                        <div className="gallery-nav-btn next" onClick={() => navigateGallery(1)}>&#10095;</div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default App;
